import { analytics } from 'utils/analytics';
import {
    AssetCategory,
    AssetCategoryGroup,
    InteractionSource,
} from 'utils/analytics/AnalyticsV2Service.generated';
import { Pack, Repack } from 'types/generated/graphql';
import { getPackAnalyticsTypeV2 } from 'helpers';

type PackPlayButtonClickTrackerV2Config = {
    item: Pack | Repack;
    interactionSource: InteractionSource;
    contentGroup?: string;
    contentList?: string;
};

interface PackPlayButtonClickTrackerV2Type {
    (config: PackPlayButtonClickTrackerV2Config): (totalTime: number) => void;
}

export const getPackPlayButtonClickTrackerV2: PackPlayButtonClickTrackerV2Type =
    ({ item, interactionSource, contentGroup, contentList }) => {
        const assetCategory = getPackAnalyticsTypeV2(item);

        const Tracker = (totalTime: number): void => {
            if (assetCategory) {
                analytics.trackAssetPlayed({
                    assetCategory,
                    assetId: item.guid,
                    interactionSource,
                    assetCategoryGroup: AssetCategoryGroup.Audio,
                    assetLength: totalTime,
                    assetName: item.name,
                    ctaContentGroup: contentGroup,
                    ctaContentList: contentList,
                });
            }
        };

        return Tracker;
    };

type CustomHeroSlidePlayButtonClickTrackerV2Config = {
    item: any;
    interactionSource: InteractionSource;
};

interface CustomHeroSlidePlayButtonClickTrackerV2Type {
    (config: CustomHeroSlidePlayButtonClickTrackerV2Config): (
        totalTime: number,
    ) => void;
}

export const getCustomHeroSlidePlayButtonClickTrackerV2: CustomHeroSlidePlayButtonClickTrackerV2Type =
    ({ item, interactionSource }) => {
        const Tracker = (totalTime: number): void => {
            analytics.trackAssetPlayed({
                assetCategory: AssetCategory.Audio,
                assetId: item.guid,
                interactionSource,
                assetCategoryGroup: AssetCategoryGroup.Audio,
                assetName: item.name,
                assetLength: totalTime,
                ctaContentGroup: undefined,
                ctaContentList: undefined,
            });
        };

        return Tracker;
    };
